t = require('views/internal/teacup-with-helpers')('label_limit_exceeded')

module.exports = ->
  t.span { class: 'error' }, ->
    t.format 'board-label-limit-exceeded'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/label_limit_exceeded.coffee